import styles from './Feature.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface FeatureItem {
  imgSrc: string
  title: string
  item1?: string
  item2?: string
  item3?: string
  item4?: string
}

interface Props {
  FeatureEach: FeatureItem[]
}

const Feature: React.FC<Props> = ({ FeatureEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.feature} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.feature__title}>特長・強み</h2>
      <div className={styles.wrapper}>
        {FeatureEach.map((feature, idx) => (
          <section className={styles.featureItem} key={idx}>
            <div className={styles.featureItem__title}>
              <img
                src={feature.imgSrc}
                alt={feature.title}
                width={40}
                height={40}
                className={styles.featureItem__title__img}
              />
              <h3 className={styles.featureItem__title__text}>{feature.title}</h3>
            </div>
            <ul className={styles.featureItem__list}>
              {[feature.item1, feature.item2, feature.item3, feature.item4].filter(Boolean).map((item, i) => (
                <li className={styles.featureItem__list__text} key={i}>
                  {item}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </section>
  )
}

export default Feature
